import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { userService } from '../../services/userService';

export const useVerifyChangeEmail = email => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: payload =>
      userService.verifyChangeEmailCode(payload).then(response => {
        const { status, data } = response;
        if (status === 200) {
          queryClient.setQueryData([QUERY_KEYS.user.profile], prevData =>
            prevData
              ? { ...prevData, email, is_email_verified: true }
              : prevData,
          );
          return { success: true, error: null };
        }
        return { success: false, error: data.message };
      }),
  });
};
